import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Spinner, Row } from "@masterteam/mt-design-react";

import { LoginForm, NewStrategyPlus } from "./components/";

import { login } from "../../reducers/user";

import styles from "./LoginPage.module.scss";

function LoginPage() {
  const [theme, user] = useSelector((store) => [store.theme, store.user]);
  const history = useHistory();

  if (user?.user?.token) {
    history.push("/");
  }

  const dispatch = useDispatch();

  const handleLogin = (values) => {
    const body = {
      UserName: values?.username,
      Password: values?.password,
    };
    dispatch(login(body));
  };

  if (theme.isLoading) {
    return (
      <Row
        style={{
          height: "100vh",
        }}
        justify="center"
        align="center"
      >
        <Spinner variant="dark" size="large" />
      </Row>
    );
  }

  return (
    <Row className={styles.loginContainer}>
      <NewStrategyPlus />
      <LoginForm onSubmit={handleLogin} loading={user.isLoading} />
    </Row>
  );
}

export default LoginPage;
